import React from "react";
import { RefreshCw, AlertCircle, WifiOff } from "lucide-react";

/**
 * Renders a compact sync-state indicator on list items.
 * Reads the three flags set by mergeOutboxItems:
 *   _is_offline  — item has local changes not confirmed by server
 *   _syncing     — currently being sent to Supabase
 *   _error       — exceeded max retries, needs manual action
 */
export default function OfflineItemBadge({ item }) {
  if (!item?._is_offline) return null;

  if (item._syncing) {
    return (
      <span title="Sincronizando…" className="inline-flex items-center shrink-0">
        <RefreshCw size={11} className="text-blue-400 animate-spin" />
      </span>
    );
  }

  if (item._error) {
    return (
      <span
        title="Error de sincronización"
        className="inline-flex items-center gap-0.5 text-[10px] font-medium text-red-500 bg-red-50 px-1.5 py-0.5 rounded-full shrink-0"
      >
        <AlertCircle size={10} />
        Error
      </span>
    );
  }

  return (
    <span title="Pendiente de sincronizar" className="inline-flex items-center shrink-0">
      <WifiOff size={11} className="text-amber-400" />
    </span>
  );
}
